import { ProviderActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ProviderFormData } from 'src/screens/General/screens/Providers/components/ProviderForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetProvidersAction {
    type: typeof ProviderActions.STAFF_FETCH_PROVIDERS;
    payload: QueryParams;
    all?: any;
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}

export function getProvidersCsv(params: QueryParamsAll): GetProvidersConfirmedMetricsAction {
    return {
        type: ProviderActions.STAFF_FETCH_PROVIDERS_CSV,
        payload: params,
        all: params.all,
    };
}

export function getProviders(params: QueryParams): GetProvidersAction {
    return {
        type: ProviderActions.STAFF_FETCH_PROVIDERS,
        payload: params,
    };
}

export interface GetProvidersConfirmedMetricsAction {
    type: typeof ProviderActions.STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS;
    payload: QueryParams;
    all?: any;
}

export function getProvidersConfirmedMetrics(params: QueryParams): GetProvidersConfirmedMetricsAction {
    return {
        type: ProviderActions.STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS,
        payload: params,
    };
}

export interface GetProvidersSmallAction {
    type: typeof ProviderActions.STAFF_FETCH_PROVIDERS_SMALL;
    payload: QueryParams;
}

export function getProvidersSmall(params: QueryParams): GetProvidersSmallAction {
    return {
        type: ProviderActions.STAFF_FETCH_PROVIDERS_SMALL,
        payload: params,
    };
}

export interface GetProvidersSupervisorAction {
    type: typeof ProviderActions.STAFF_FETCH_SUPERVISOR_PROVIDERS;
    payload: QueryParams;
}

export function getSupervisorProviders(params: QueryParams): GetProvidersSupervisorAction {
    return {
        type: ProviderActions.STAFF_FETCH_SUPERVISOR_PROVIDERS,
        payload: params,
    };
}

export interface GetProviderAction {
    type: typeof ProviderActions.STAFF_FETCH_PROVIDER;
    payload: {
        id: string | number;
    };
}

export function getProvider(id: string | number): GetProviderAction {
    return {
        type: ProviderActions.STAFF_FETCH_PROVIDER,
        payload: { id },
    };
}

export interface DeleteProviderAction {
    type: typeof ProviderActions.STAFF_DELETE_PROVIDER;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteProvider(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteProviderAction {
    return {
        type: ProviderActions.STAFF_DELETE_PROVIDER,
        payload: { id, onSuccess, onError },
    };
}

export interface DeleteFileProviderAction {
    type: typeof ProviderActions.STAFF_DELETE_FILE_PROVIDER;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileProvider(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileProviderAction {
    return {
        type: ProviderActions.STAFF_DELETE_FILE_PROVIDER,
        payload: { id, onSuccess, onError },
    };
}

export interface CreateFilesProviderAction {
    type: typeof ProviderActions.STAFF_CREATE_FILES_PROVIDER;
    payload: {
        id: number | string;
        requestType: string;
        files: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createFilesProvider(
    id: number | string,
    requestType: string,
    files: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateFilesProviderAction {
    return {
        type: ProviderActions.STAFF_CREATE_FILES_PROVIDER,
        payload: {
            id,
            requestType,
            files,
            onSuccess,
            onError,
        },
    };
}

export interface PersistProviderAction {
    type: typeof ProviderActions.STAFF_PERSIST_PROVIDER;
    payload: {
        data: ProviderFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistProvider(
    data: ProviderFormData,
    files: any,
    callbacks: SagaPromise<any>,
): PersistProviderAction {
    return {
        type: ProviderActions.STAFF_PERSIST_PROVIDER,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistProvider = (data: ProviderFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistProvider(data, files, { resolve, reject }));
    });
};
/*
export function asyncPersistProvider(data: ProviderFormData, callbacks: SagaPromise<any>): PersistProviderAction {
    return {
        type: ProviderActions.STAFF_PERSIST_PROVIDER,
        payload: {
            data,
            callbacks,
        },
    };
}


export interface PersistProviderAction {
    type: typeof ProviderActions.STAFF_PERSIST_PROVIDER,;
    payload: {
        data: ProviderFormData;
        callbacks: SagaPromise<any>;
    };
}
*/

export interface GetFilesAction {
    type: typeof ProviderActions.STAFF_FETCH_FILES_PROVIDER;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: ProviderActions.STAFF_FETCH_FILES_PROVIDER,
        payload: { id },
    };
}

export interface UpdateProviderAction {
    type: typeof ProviderActions.STAFF_UPDATE_PROVIDER;
    payload: {
        data: Partial<ProviderFormData>;
        callbacks: SagaPromise<any>;
    };
}

export function updateProvider(data: Partial<ProviderFormData>, callbacks: SagaPromise<any>): UpdateProviderAction {
    return {
        type: ProviderActions.STAFF_UPDATE_PROVIDER,
        payload: {
            data,
            callbacks,
        },
    };
}
export const asyncUpdateProvider = (
    data: Partial<ProviderFormData>,
    dispatch: Dispatch,
    success: () => void,
    fail: (reject: any) => void,
) => {
    return new Promise((resolve, reject) => {
        dispatch(
            updateProvider(data, {
                resolve: (resolve) => {
                    success();
                },
                reject: (reject) => {
                    fail(reject);
                },
            }),
        );
    });
};

export type Actions =
    | GetProvidersAction
    | GetProvidersConfirmedMetricsAction
    | GetProviderAction
    | DeleteProviderAction
    | PersistProviderAction
    | GetFilesAction
    | GetProvidersSupervisorAction
    | DeleteFileProviderAction
    | GetProvidersSmallAction;
